import { render, staticRenderFns } from "./ImageUploaderButton.vue?vue&type=template&id=5741b2ef&scoped=true&"
import script from "./ImageUploaderButton.vue?vue&type=script&lang=js&"
export * from "./ImageUploaderButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploaderButton.vue?vue&type=style&index=0&id=5741b2ef&lang=scss&scoped=true&"
import style1 from "./ImageUploaderButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5741b2ef",
  null
  
)

export default component.exports